import React from 'react';
import './Footer.scss';

const Footer = () => {
    return(
    <div  className='footer'>
        <p className='copyright'>&copy; 2021 <span className="medium">LeanWisdom</span></p>
        <div className="brand-logo">
        <a className="goodux-logo" href="http://goodux.in/" target="_blank">
            <img src='./assets/images/svg/uxuibygood.svg' />
        </a>
            <div className="goodux-name">" UX . UI by GoodUX "</div>
        </div>
    </div>
    );
}
export default Footer;


// WEBPACK FOOTER //
// ./common/Footer/Footer.js